import axios from 'axios';
import { req } from './axiosFun';

// 定义通用api前缀
//专利镖局小程序后台接口url前缀(本地)
// var wechatRoot = 'http://192.168.2.134/index.php';
//专利镖局小程序后台接口url前缀(线上)
// var wechatRoot = 'https://zlbb.qzhip.com/index.php';

//高企认定小程序后台接口url前缀(本地)
// var gqchatRoot = 'http://gqrd.test.cn/index.php';
//高企认定小程序后台接口url前缀(线上)
var gqchatRoot = 'https://gqrd.qzhip.com/index.php';
/**
 * 专利镖局API
 **/

// 专利微信-专利缴费
export const wechatFeePayList = (params) => { return req("post",  "/admin/patent/patentPayList", params) };
// 专利卫士-处理缴费
export const wechatHandleFee = (params) => { return req("post",  "/admin/patent/changePayStatus", params) };
// 专利卫士-批量处理缴费
export const wechatCheckHandleFee = (params) => { return req("post",  "/admin/patent/changeCheckPayStatus", params) };
// 专利卫士-导出勾选年费订单
export const exportPayExcel = (params) => { return req("post",  "/admin/patent/exportPayExcel", params) };
// 专利卫士-导出满足条件年费订单
export const exportPayAllExcel = (params) => { return req("post",  "/admin/patent/exportPayAllExcel", params) };
// 专利卫士-批量处理订单服务费开票
export const wechatCheckServiceBill = (params) => { return req("post",  "/admin/patent/changeCheckServiceBill", params) };
// 专利卫士-提交服务费发票
export const editTicketApply = (params) => { return req("post",  "/admin/patent/editTicketApply", params) };
// 发票管理-上传年费发票
export const wechatUploadBill = (params) => { return req("post",  "/admin/patent/uploadBill", params) };
// 发票管理-查询发票列表
export const wechatBillList = (params) => { return req("post",  "/admin/patent/getBillList", params) };
// 发票管理-删除发票
export const wechatDelBill = (params) => { return req("post",  "/admin/patent/delBill", params) };
// 发票管理-发送服务费发票
export const sendTicket = (params) => { return req("post",  "/admin/patent/sendTicket", params) };
// 专利卫士-处理订单服务费开票
export const wechatServiceBill = (params) => { return req("post",  "/admin/patent/changeServiceBill", params) };
// 专利卫士-查询服务费发票申请列表
export const getTicketApply = (params) => { return req("post",  "/admin/patent/getTicketApply", params) };
// 专利镖局-订单详情
export const patentPayInfo = (params) => { return req("post",  "/admin/patent/patentPayInfo", params) };
// 专利卫士-提交退款
export const patentRefundFee = (params) => { return req("post",  "/admin/patent/refundFee", params) };
// 专利镖局-专利监控
export const wechatPatMonList = (params) => { return req("post",  "/admin/patent/index", params) };
// 专利镖局-提醒管理
export const wechatPatRemList = (params) => { return req("post",  "/admin/patent/remindList", params) };
// 专利镖局-提醒管理-发送提醒
export const wechatPatSenRem = (params) => { return req("post",  "/admin/patent/sendRemind", params) };
// 专利镖局-PDF订单
export const wechatOrderPdf = (params) => { return req("post",  "/admin/patent/getPdfOrderList", params) };
// 专利镖局-用户管理
export const wechatUserList = (params) => { return req("post",  "/admin/patent/userList", params) };
// 专利镖局-API日志
export const wechatApiList = (params) => { return req("post",  "/admin/patent/userLogList", params) };
// 专利镖局-API日志-删除勾选的记录
export const wechatApiDelCheck = (params) => { return req("post",  "/admin/patent/delUserLogCheck", params) };
// 专利镖局-API日志-删除满足检索条件的记录
export const wechatApiDelSearch = (params) => { return req("post",  "/admin/patent/delUserLogSearch", params) };
// 专利镖局-退款管理
export const wechatRefund = (params) => { return req("post",  "/admin/refund/getRefundList", params) };
// 专利镖局-退款审核
export const wechatCheckRefund = (params) => { return req("post",  "/admin/refund/editRefund", params) };
// 专利卫士-规费指引-列表
export const getGuidePageList = (params) => { return req("post",  "/admin/guide/getGuidePageList", params) };
// 专利卫士-规费指引-编辑
export const editGuide = (params) => { return req("post",  "/admin/guide/editGuide", params) };
// 专利卫士-规费指引-删除
export const delGuide = (params) => { return req("post",  "/admin/guide/delGuide", params) };
// 专利卫士-组织国家-列表
export const getCountryPageList = (params) => { return req("post",  "/admin/guide/getCountryPageList", params) };
// 专利卫士-组织国家-编辑
export const editCountry = (params) => { return req("post",  "/admin/guide/editCountry", params) };
// 专利卫士-组织国家-删除
export const delCountry = (params) => { return req("post",  "/admin/guide/delCountry", params) };
// 专利卫士-预审优审中心-列表
export const getPreExaminePageList = (params) => { return req("post",  "/admin/guide/getPreExamine", params) };
// 专利卫士-预审优审中心-编辑
export const editPreExamine = (params) => { return req("post",  "/admin/guide/editPreExamine", params) };
// 专利卫士-预审优审中心-删除
export const delPreExamine = (params) => { return req("post",  "/admin/guide/delPreExamine", params) };
// 专利卫士-预审优审中心-查询资料文档
export const getPreExamineDoc = (params) => { return req("post",  "/admin/guide/getPreExamineDoc", params) };
// 专利卫士-预审优审中心-编辑资料文档
export const editCenterDoc = (params) => { return req("post",  "/admin/guide/editCenterDoc", params) };
// 专利卫士-预审优审中心-删除资料文档
export const delCenterDoc = (params) => { return req("post",  "/admin/guide/delCenterDoc", params) };
// 专利卫士-预审优审中心-查询支持分类号
export const getCenterIpc = (params) => { return req("post",  "/admin/guide/getCenterIpc", params) };
// 专利卫士-预审优审中心-上传分类号
export const uploadCenterIpc = (params) => { return req("post",  "/admin/guide/uploadCenterIpc", params) };
// 专利卫士-预审优审中心-清除分类号
export const delCenterIpcData = (params) => { return req("post",  "/admin/guide/delCenterIpcData", params) };


// 专利卫士-价值评估-列表
export const getReportOrderList = (params) => { return req("post",  "/admin/Report/getReportOrderList", params) };
// 专利卫士-价值评估-订单导出(勾选)
export const exportCheckReportOrder = (params) => { return req("post",  "/admin/Report/exportCheckReportOrder", params) };
// 专利卫士-价值评估-订单导出(满足条件)
export const exportSearchReportOrder = (params) => { return req("post",  "/admin/Report/exportSearchReportOrder", params) };
// 专利卫士-申请预评估-列表
export const getPreReportOrderList = (params) => { return req("post",  "/admin/Report/getPreReportOrderList", params) };
// 专利卫士-申请预评估-订单导出(勾选)
export const exportCheckPreReportOrder = (params) => { return req("post",  "/admin/Report/exportCheckPreReportOrder", params) };
// 专利卫士-申请预评估-订单导出(满足条件)
export const exportSearchPreReportOrder = (params) => { return req("post",  "/admin/Report/exportSearchPreReportOrder", params) };
// 专利卫士-积分充值订单-列表
export const getRechargeOrderList = (params) => { return req("post",  "/admin/order/getRechargeOrderList", params) };
// 专利卫士-等级提升订单-列表
export const getUpgradeOrderList = (params) => { return req("post",  "/admin/order/getUpgradeOrderList", params) };


/**
 * 高企认定API
 **/
 // 高企认定-用户管理
export const gqchatUserList = (params) => { return req("post", gqchatRoot + "/admin/user/qzUserList", params) };
// 高企认定-报告管理
export const gqchatReportList = (params) => { return req("post", gqchatRoot + "/admin/export/qzExportList", params) };
// 高企认定-报告管理-报告详情
export const gqchatReportInfo = (params) => { return req("post", gqchatRoot + "/admin/export/qzExportInfo", params) };
// 高企认定-报告管理-删除（单个）
export const gqchatReportDel = (params) => { return req("post", gqchatRoot + "/admin/export/delReport", params) };
// 高企认定-报告管理-删除（勾选）
export const gqchatReportDelCheck = (params) => { return req("post", gqchatRoot + "/admin/export/delCheckReport", params) };
// 高企认定-API日志
export const gqchatApiList = (params) => { return req("post", gqchatRoot + "/admin/user/userLogList", params) };


export const wechatUrl = 'https://zlbb.qzhip.com/index.php';
export const wechatRoot = 'https://zlbb.qzhip.com/index.php';

export const gqchatUrl = 'https://gqrd.qzhip.com/index.php';
// export const gqchatRoot = 'https://gqrd.qzhip.com/index.php';


// WEBPACK FOOTER //
// ./src/api/wechatMG.js